import React from 'react';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

import { breakpoints } from 'utils/breakpoint';

export default function getCarouselProps(
    { deskTopSlidesToShow = 3 } = {},
    arrows = true,
    draggable = false
) {
    return {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: deskTopSlidesToShow,
        slidesToScroll: 1,
        initialSlide: 0,
        prevArrow: <BeforeIcon />,
        nextArrow: <NextIcon />,
        arrows: arrows,
        draggable: draggable,
        responsive: [
            {
                breakpoint: breakpoints.xsm,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '5%'
                }
            }
        ]
    };
}

function BeforeIcon({ className, style, onClick }) {
    return <NavigateBeforeIcon className={className} style={style} onClick={onClick} />;
}

function NextIcon({ className, style, onClick }) {
    return <NavigateNextIcon className={className} style={style} onClick={onClick} />;
}
